import {Flex} from 'antd';
import {ReactElement, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {getReviewLogUserDisplayName, ReviewLogUserType} from '../../../../../../../../service/reviews/reviews-logs';
import {LogActionsEnum} from '../../../../../review-logs/review-log-type';

type PropsType = {
    action: LogActionsEnum;
    companyDisplayName: string;
    formattedDate: string | null;
    formattedTime: string | null;
    user: ReviewLogUserType | null;
};

export function VisibilityLog(props: PropsType): ReactElement {
    const {action, companyDisplayName, formattedDate, formattedTime, user} = props;

    const knownUserDisplayName = user ? getReviewLogUserDisplayName(user) : null;

    const actionLocaleString = useMemo((): LangKeyType => {
        const isHidden = action === LogActionsEnum.Created;

        if (knownUserDisplayName) {
            return isHidden ? 'REVIEWS__REVIEW_LOG__HIDDEN__BY_USER' : 'REVIEWS__REVIEW_LOG__UNHIDDEN__BY_USER';
        }

        return isHidden ? 'REVIEWS__REVIEW_LOG__HIDDEN' : 'REVIEWS__REVIEW_LOG__UNHIDDEN';
    }, [action, knownUserDisplayName]);

    return (
        <Flex gap={4} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Text
                block
                lighter
                stringKey={actionLocaleString}
                valueMap={{user: <Text bolder>{knownUserDisplayName ?? companyDisplayName}</Text>}}
            />
        </Flex>
    );
}
